import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    const url = orig?.url || "";
    if (error.response?.status === 401 && !orig._retry && !url.includes("/auth/login") && !url.includes("/auth/refresh")) {
      orig._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch (e) {
        /* fallthrough */
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Une erreur est survenue.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const money = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "USD" }).format(v || 0);

export const fdate = (s) => (s ? new Date(s).toLocaleDateString("fr-FR") : "—");

export async function downloadPdf(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const STATUS = {
  brouillon: ["Brouillon", "bg-slate-100 text-slate-700 border-slate-300"],
  soumis: ["Soumis à la direction", "bg-amber-50 text-amber-700 border-amber-200"],
  approuve: ["Validé", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  rejete: ["Rejeté", "bg-red-50 text-red-700 border-red-200"],
  commande: ["Transformé en commande", "bg-blue-50 text-blue-700 border-blue-200"],
  en_cours: ["En cours", "bg-blue-50 text-blue-700 border-blue-200"],
  livree: ["Livrée", "bg-sky-50 text-sky-700 border-sky-200"],
  facturee: ["Facturée", "bg-indigo-50 text-indigo-700 border-indigo-200"],
  en_attente: ["En attente", "bg-amber-50 text-amber-700 border-amber-200"],
  partiel: ["Paiement partiel", "bg-orange-50 text-orange-700 border-orange-200"],
  paye: ["Payée", "bg-teal-50 text-teal-700 border-teal-200"],
  planifiee: ["Planifiée", "bg-slate-100 text-slate-700 border-slate-300"],
  terminee: ["Terminée", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  actif: ["Actif", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  conge: ["En congé", "bg-amber-50 text-amber-700 border-amber-200"],
  sorti: ["Sorti", "bg-slate-100 text-slate-500 border-slate-300"],
  demande: ["Demandé", "bg-amber-50 text-amber-700 border-amber-200"],
  refuse: ["Refusé", "bg-red-50 text-red-700 border-red-200"],
  nouvelle: ["Nouvelle", "bg-red-50 text-red-700 border-red-200"],
  en_traitement: ["En traitement", "bg-amber-50 text-amber-700 border-amber-200"],
  devis: ["Devis établi", "bg-blue-50 text-blue-700 border-blue-200"],
  cloturee: ["Clôturée", "bg-slate-100 text-slate-600 border-slate-300"],
  publie: ["Publiée", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  erreur: ["Erreur", "bg-red-50 text-red-700 border-red-200"],
};

export const ROLES = { admin: "Direction", commercial: "Commercial", technicien: "Technicien", rh: "Ressources humaines" };

export const CATEGORIES = {
  genie_civil: { label: "Génie civil", color: "#DC2626" },
  genie_electrique: { label: "Génie électrique", color: "#D97706" },
  transport: { label: "Transport & logistique", color: "#1E3A8A" },
  formation: { label: "Formation & main d'œuvre", color: "#059669" },
  informatique: { label: "Informatique", color: "#0284C7" },
};

export const can = (user, ...roles) => user && (user.role === "admin" || roles.includes(user.role));
